import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { RouteSource } from '../../graph/schema-generated-types-educator';
import { NavigationItems } from '../../types';

const getTranslation = (key) => translate('menu', key);

export const getNavigationItems = (): NavigationItems[] => [
  {
    to: '/home',
    text: getTranslation('teacherDashboard'),
    title: 'teacherDashboard',
  },
  {
    to: '/assignments',
    text: getTranslation('assignments'),
    title: 'assignments',
  },
  {
    to: '/reports',
    text: getTranslation('studentReporting'),
    from: RouteSource.MAIN_MENU,
    title: 'studentReporting',
  },
  {
    to: '/teachers-guide',
    from: RouteSource.MAIN_MENU,
    text: getTranslation('teachersGuide'),
    title: 'teachers-guide',
  },
  {
    to: '/letter-books',
    from: RouteSource.MAIN_MENU,
    text: getTranslation('letterBooks'),
    title: 'letterBooks',
  },
  {
    to: '/student-practice-book',
    from: RouteSource.MAIN_MENU,
    text: getTranslation('studentPracticeBook'),
    title: 'studentPracticeBook',
  },
  {
    to: '/resources',
    from: RouteSource.MAIN_MENU,
    text: getTranslation('resources'),
    title: 'resources',
  },
  {
    to: '/help-and-support',
    text: getTranslation('helpAndSupport'),
    sendTelemetryEvent: true,
    title: 'helpAndSupport',
  },
  {
    to: '/professional-learning',
    from: RouteSource.MAIN_MENU,
    text: getTranslation('professionalLearning'),
    sendTelemetryEvent: true,
    title: 'professionalLearning',
  },
  {
    to: '/preferences',
    from: RouteSource.MAIN_MENU,
    text: getTranslation('preferencesAndClassSettings'),
    sendTelemetryEvent: true,
    title: 'preferencesAndClassSettings',
  },
];
